import {QuickbetXTrackingAction, QuickbetXTrackingState, QuickbetXTrackingActionTypes} from "../../types/QuickbetX/quickbetXTrackingTypes";

const initialState: QuickbetXTrackingState = {
    quickbetXTrackingeData: [],
    quickbetXTrackingeLoading: false,
    quickbetXTrackingeError: null,
};

export const quickbetXTrackingReducer = (state = initialState, action: QuickbetXTrackingAction): QuickbetXTrackingState => {
    switch (action.type) {
        case QuickbetXTrackingActionTypes.FETCH_QUICKBET_X_TRACKING_DATA:
            return { ...state, quickbetXTrackingeLoading: true, quickbetXTrackingeError: null, quickbetXTrackingeData: [] };
        case QuickbetXTrackingActionTypes.FETCH_QUICKBET_X_TRACKING_DATA_SUCCESS:
            return { ...state, quickbetXTrackingeLoading: false, quickbetXTrackingeError: null, quickbetXTrackingeData: action.payload };
        case QuickbetXTrackingActionTypes.FETCH_QUICKBET_X_TRACKING_DATA_ERROR:
            return { ...state, quickbetXTrackingeLoading: false, quickbetXTrackingeError: action.payload, quickbetXTrackingeData: [] };
        default:
            return state;
    }
};
